/**
 * MVP: link surveys to a season via SeasonSurvey junction only (no CompanySurvey payload).
 * Full global-challenge + campaign UI lives on branch wip/season-quiz-full.
 */

export function draftFromSeasonSeasonSurveysMvp(season) {
	const rows = (season && season.seasonSurveys) || []
	return rows.map((ss, idx) => {
		const survey = ss.survey || {}
		return {
			surveyId: ss.surveyId,
			sortOrder: ss.sortOrder != null ? ss.sortOrder : idx,
			enabled: ss.enabled !== false,
			title: survey.title,
			tag: survey.tag,
		}
	})
}

/** Wire shape for modifySeason / addSeason: junction rows only (backend sync still requires non-empty companyIds separately). */
export function packSeasonSurveysPayloadMvp(draft) {
	if (!draft || !draft.length) return []
	return draft.map((row, i) => ({
		surveyId: row.surveyId,
		sortOrder: row.sortOrder != null ? row.sortOrder : i,
		enabled: row.enabled !== false,
		companyCampaign: [],
	}))
}
